import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const CustomColorSelect = ({ 
  value, 
  onChange, 
  options, 
  placeholder = "Seleccionar",
  disabled = false,
  className = ""
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [openUp, setOpenUp] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen]);

  const selectedOption = options.find(opt => opt.value === value);

  return (
    <div ref={dropdownRef} className={`relative ${className}`}>
      {/* Select button */}
      <button
        ref={buttonRef}
        type="button"
        onClick={() => {
          if (disabled) return;
          if (!isOpen && buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            setOpenUp(spaceBelow < 250);
          }
          setIsOpen(!isOpen);
        }}
        disabled={disabled}
        className={`w-full px-3 py-2 text-left border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white flex items-center justify-between ${
          disabled ? 'bg-gray-100 cursor-not-allowed' : 'cursor-pointer hover:bg-gray-50'
        } ${className}`}
      >
        <span className="flex items-center gap-2">
          {selectedOption ? (
            <>
              {selectedOption.color && (
                <div 
                  className="w-3 h-3 rounded-full border border-gray-400 flex-shrink-0"
                  style={{ backgroundColor: selectedOption.color }}
                />
              )}
              <span className={selectedOption.disabled ? 'text-red-600' : ''}>
                {selectedOption.label}
              </span>
            </>
          ) : (
            <span className="text-gray-400">{placeholder}</span>
          )}
        </span>
        <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {/* Dropdown menu */}
      {isOpen && (
        <div className="absolute z-50 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto"
          style={openUp ? { bottom: "100%", marginBottom: "4px" } : { top: "100%", marginTop: "4px" }}>
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => {
                if (!option.disabled) {
                  onChange(option.value);
                  setIsOpen(false);
                }
              }}
              disabled={option.disabled}
              className={`w-full px-3 py-2 text-left flex items-center gap-2 hover:bg-gray-100 ${
                option.disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
              } ${value === option.value ? 'bg-blue-50' : ''}`}
            >
              {option.color && (
                <div 
                  className="w-3 h-3 rounded-full border border-gray-400 flex-shrink-0"
                  style={{ backgroundColor: option.color }}
                />
              )}
              <span className={`flex-1 ${option.disabled ? 'text-red-600 font-bold' : ''}`}>
                {option.label}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomColorSelect;
